











































































































































































































































import { Vue, Component, Prop } from "@/shared/vuepack";
import { useContactInfoStore } from "@/shared/store/contactinfo";
import { useThemeStore } from "@/shared/store/theme";
import {
  ContactInformation,
  EmployerEmployeeProfileSettingValue,
  MaritalStatus
} from "@/shared/types";
import UsStateSelector from "@/shared/components/UsStateSelector.vue";

const fieldDisabledMessage = "This field has been locked by your employer. Please contact your employer directly to make changes.";

@Component({
  components: {
    UsStateSelector
  }
})
export default class EditProfile extends Vue {
  contactInfoStore = useContactInfoStore();
  themeStore = useThemeStore();
  MaritalStatus = MaritalStatus;
  isSubmitting = false;
  fieldDisabledMessage = fieldDisabledMessage;

  @Prop({ required: true })
  contactInfo: ContactInformation;

  @Prop({ required: true })
  onSave: () => Promise<void>;

  @Prop({ required: true })
  toggleClose: () => void;

  @Prop({ required: true })
  show: { value: boolean };

  get submitDisabled () {
    return !this.isValid || this.isSubmitting;
  }

  get isValid () {
    return !this.$validator.errors.any();
  }

  get fieldEditSettings () {
    return this.contactInfoStore.contactInformation.fieldEditSettings;
  }

  save () {
    this.$validator.validateAll().then(result => {
      if (!result) {
        return;
      }

      this.isSubmitting = true;

      this.onSave().finally(() => {
        this.isSubmitting = false;
      });
    });
  }

  isFieldDisabled (value: EmployerEmployeeProfileSettingValue) {
    return value !== EmployerEmployeeProfileSettingValue.Edit;
  }
}
